import { RouteInfo } from './vertical-menu.metadata';

//Sidebar menu Routes and data
export const ROUTES: RouteInfo[] = [

  {
    path: '/dashboard', title: 'Scanned IDs', icon: 'fas fa-chart-line', class: '', badge: '', badgeClass: '', isExternalLink: false, submenu: []
  },
  {
    path: '/customer', title: 'Customers', icon: 'fas fa-users', class: '', badge: '', badgeClass: '', isExternalLink: false, submenu: []
  },
  {
    path: '/scanned-activity', title: 'Scan Activity ', icon: 'fas fa-file', class: '', badge: '', badgeClass: '', isExternalLink: false, submenu: []
  },
  {
    path: '/import-insights', title: 'Import Insights ', icon: 'fas fa-analytics', class: '', badge: '', badgeClass: '', isExternalLink: false, submenu: []
  },
  // {
  //   path: '/tracked-assets', title: 'Tracked Assets', icon: 'ft-layers', class: '', badge: '', badgeClass: '', isExternalLink: false, submenu: []
  // },
  // {
  //   path: '/track-history', title: 'Track History', icon: 'ft-list', class: '', badge: '', badgeClass: '', isExternalLink: false, submenu: []
  // },

  // {
  //   path: '/asset-pools', title: 'Asset Pools', icon: 'ft-truck', class: '', badge: '', badgeClass: '', isExternalLink: false, submenu: []
  // },

  // {
  //   path: '/subscription', title: 'Subscription', icon: 'ft-settings', class: 'dropdown nav-item has-sub', badge: '', badgeClass: '', isExternalLink: false,
  //   submenu: [
  //     {
  //       path: '/subscription/function', title: 'Function', icon: 'ft-arrow-right', class: 'dropdown-item', badge: '', badgeClass: '', isExternalLink: false, submenu: []
  //     },
  //     {
  //       path: '/subscription/feature', title: 'Feature', icon: 'ft-arrow-right', class: 'dropdown-item', badge: '', badgeClass: '', isExternalLink: false, submenu: []
  //     },
  //     {
  //       path: '/subscription/module', title: 'Module', icon: 'ft-arrow-right', class: 'dropdown-item', badge: '', badgeClass: '', isExternalLink: false, submenu: []
  //     },
  //     // {
  //     //   path: '/subscription/feature-function', title: 'Feature Function', icon: 'ft-arrow-right', class: 'dropdown-item', badge: '', badgeClass: '', isExternalLink: false, submenu: []
  //     // },
  //     {
  //       path: '/subscription/subscription-type', title: 'Subscription Plan Type', icon: 'ft-arrow-right', class: 'dropdown-item', badge: '', badgeClass: '', isExternalLink: false, submenu: []
  //     },
  //     {
  //       path: '/subscription/subscription', title: 'Subscription', icon: 'ft-arrow-right', class: 'dropdown-item', badge: '', badgeClass: '', isExternalLink: false, submenu: []
  //     },
  //     {
  //       path: '/subscription/company', title: 'Company', icon: 'ft-arrow-right', class: 'dropdown-item', badge: '', badgeClass: '', isExternalLink: false, submenu: []
  //     },
  //   ]
  // },

  // {
  //   path: '/access-management', title: 'User Access', icon: 'ft-user', class: 'dropdown nav-item has-sub', badge: '', badgeClass: '', isExternalLink: false,
  //   submenu: [
  //     {
  //       path: '/access-management/designations', title: 'Designations', icon: 'ft-arrow-right', class: 'dropdown-item', badge: '', badgeClass: '', isExternalLink: false, submenu: []
  //     },
  //     {
  //       path: '/access-management/employees', title: 'Employees', icon: 'ft-arrow-right', class: 'dropdown-item', badge: '', badgeClass: '', isExternalLink: false, submenu: []
  //     },
  //     {
  //       path: '/access-management/roles', title: 'Roles', icon: 'ft-arrow-right', class: 'dropdown-item', badge: '', badgeClass: '', isExternalLink: false, submenu: []
  //     },
  //     {
  //       path: '/access-management/users', title: 'Users', icon: 'ft-arrow-right', class: 'dropdown-item', badge: '', badgeClass: '', isExternalLink: false, submenu: []
  //     },
  //   ]
  // },
];
